import React, { Component } from 'react';
import lodashGet from 'lodash/get';
import { Loader, Header } from 'semantic-ui-react';
import { connect } from 'react-redux';

import * as actions from '../../../actions';
import { POST_COMMENTS_LIMIT } from '../../../constants';
import { selectPostInfoResults } from '../../../selectors';

// Code splitting
import Comments from './Comments';
import CustomInfiniteScroll from '../../common/CustomInfiniteScroll';
import Gallery from '../../common/Gallery';
import Info from './Info';

class Post extends Component {
  constructor(props) {
    super(props);
    const { id } = this.props;
    this.state = {
      id,
      offset: 0,
    };
  }

  componentDidMount() {
    if (this.state.id !== lodashGet(this.props.info, 'id')) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.id !== this.state.id) {
      this.fetchData();
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.id !== state.id) {
      return { id: props.id };
    }
    return null;
  }

  fetchData = () => {
    const {
      getPostComments,
      getPostInfo,
    } = this.props;

    const { id } = this.state;

    getPostInfo(id).then(r => {
      if (r.value && r.value.data) {
        const { title, forum } = r.value.data;
        this.props.setSeo({
          title: `Dcard | ${title}`,
          description: `Dcard | ${r.value.data.excerpt?.replace(/\s/g, '')}`,
        });
      }
    });
    getPostComments(id, POST_COMMENTS_LIMIT, 0);
  };

  hasMoreComments = ({ data, total }) => {
    if (!Array.isArray(data) || !data.length) {
      return false;
    }
    return data.length < total;
  };

  fetchMoreComments = () => {
    const { id } = this.state;
    const {
      comments: { isFetching },
    } = this.props;

    if (isFetching) {
      return;
    }
    const { getPostComments } = this.props;
    const { offset } = this.state;
    getPostComments(id, POST_COMMENTS_LIMIT, offset + POST_COMMENTS_LIMIT).then(
      () =>
        this.setState({
          offset: offset + POST_COMMENTS_LIMIT,
        }),
    );
  };

  renderGallery = () => {
    const { info } = this.props;

    if (info.with_images) {
      if (Array.isArray(info.media) && info.media.length > 0) {
        return <Gallery urls={info.media.map(m => m.url)} />;
      }
      return <Gallery data={info.content} />;
    }

    return null;
  };

  render() {
    const { authed, comments, info, isFetching, isMobile } = this.props;

    if (isFetching) {
      return <Loader active inline="centered" />;
    }

    if (!info) {
      return <Header as="h1" content="Oops..沒有找到這篇文章喔" color="grey" />;
    }

    const shouldDimAdultContent = info.forum.requires_18 && !authed;

    return (
      <>
        <Info
          data={info}
          isFetching={isFetching}
          isMobile={isMobile}
          authed={authed}
          shouldDimAdultContent={shouldDimAdultContent}
        />
        {!shouldDimAdultContent && this.renderGallery()}
        {!shouldDimAdultContent && (
          <CustomInfiniteScroll
            dataLength={Array.isArray(comments.data) ? comments.data.length : 0}
            fetchMore={this.fetchMoreComments}
            hasMore={this.hasMoreComments(comments)}
          >
            <Comments
              data={comments.data}
              total={comments.total}
              isMobile={isMobile}
            />
          </CustomInfiniteScroll>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  comments: state.post.comments,
  info: selectPostInfoResults(state),
  isFetching: state.post.info.isFetching,
  isMobile: state.browser.lessThan.medium,
});

export default connect(mapStateToProps, actions)(Post);
